export default "__VITE_ASSET__DPOnsCzS__"